module.exports = __webpack_public_path__ + "static/media/comp.920df02d.svg";